"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRetryableStatus = exports.isRetryableError = void 0;
const ResponseError_1 = require("./ResponseError");
function isRetryableError(error) {
    return isRetryableStatus(ResponseError_1.getErrorDetails(error).status);
}
exports.isRetryableError = isRetryableError;
function isRetryableStatus(status) {
    let result = true;
    const statusGroup = status === undefined ? undefined : Math.floor(status / 100);
    switch (statusGroup) {
        case 2:
        case 4:
            result = false;
            break;
        default:
            result = true;
    }
    switch (status) {
        case 408:
        case 423:
        case 429:
            result = true;
            break;
        case 501:
            result = false;
            break;
    }
    return result;
}
exports.isRetryableStatus = isRetryableStatus;
//# sourceMappingURL=isRetryableError.js.map